import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import DashboardCard from './DashboardCard';
import {
  Table, Thead, Tr, Td, ScrollBox,
} from '../styles';
import { formatNumber } from '../constants';

// Kart 6/7 — Bekleyen havuz: en uzun bekleyen 10 başvuru. Satır tıklaması
// /ats/applications/{applicationId} adresine gider (mevcut rota,
// routes/index.js:545 — AtsApplicationDetailsPage).
export default function AgingPoolCard({ data, loading }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const rows = useMemo(() => (
    [...(data || [])]
      .sort((a, b) => (b.daysInPipeline ?? 0) - (a.daysInPipeline ?? 0))
      .slice(0, 10)
  ), [data]);

  const openApplication = (applicationId) => {
    if (!applicationId) return;
    history.push(`/ats/applications/${applicationId}`);
  };

  return (
    <DashboardCard
      cardKey="bekleyen-havuz"
      title={t('atsDashboard.aging.title')}
      meta={t('atsDashboard.aging.meta')}
      span={7}
      spanMd={6}
      loading={loading}
      empty={rows.length === 0}
      domId="ats-dash-aging"
    >
      <ScrollBox>
        <Table>
          <Thead>
            <tr>
              <th>{t('atsDashboard.aging.columnCandidate')}</th>
              <th>{t('atsDashboard.aging.columnJobTitle')}</th>
              <th>{t('atsDashboard.aging.columnStage')}</th>
              <th>{t('atsDashboard.aging.columnDays')}</th>
            </tr>
          </Thead>
          <tbody>
            {rows.map((row) => (
              <Tr
                key={row.applicationId}
                $clickable
                onClick={() => openApplication(row.applicationId)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter') openApplication(row.applicationId); }}
              >
                <Td>{row.candidateName}</Td>
                <Td>{row.jobTitle}</Td>
                <Td>{row.stageName}</Td>
                <Td>{t('atsDashboard.aging.daysValue', { count: formatNumber(row.daysInPipeline, i18n.language) })}</Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </ScrollBox>
    </DashboardCard>
  );
}
